import { render } from "./FavoContents.vue?vue&type=template&id=e606fe4a"
import script from "./FavoContents.vue?vue&type=script&lang=js"
export * from "./FavoContents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__